import { combineReducers } from "redux";
import allAccountsOverviewReducer from "../AllAccountsOverview/state/slices/allAccountsOverviewSlice";
import overviewFiltersReducer from "../AllAccountsOverview/state/slices/accountsFiltersSlice";
import createAccountReducer from "../CreateAccount/state/slices/createAccountSlice";
import editAccountReducer from "../EditAccount/state/editAccountReducer";
import mostAccessedAccountsReducer from "../MostAccessedAccounts/state/mostAccessedAccountsReducer";
import identityProvidersReducer from "./reducers/identityProvidersReducer";
import contractTypesReducer from "./slices/contractTypesSlice";
import subscriptionAgreementReducer from "./slices/subscriptionAgreementSlice";
import apiKeysReducer from "../Api/state/slices/apiKeysSlice";
import integrationReducer from "../Integrations/integrationReducer";
import accountInformationReducer from "../AccountInformation/state/accountInformationReducer";
import emailSettingsReducer from "../EmailSettings/state/slices/emailSettingsSlice";
import threatDefenceSettingsReducer from "../EditAccount/ThreatDefense/state/slices/threatDefenceSettingsSlice";
import threatDefenceSmtpSettingsReducer from "../EditAccount/ThreatDefense/state/slices/threatDefenceSmtpSettingsSlice";
import systemNotificationSettingsReducer from "../EmailSettings/state/slices/systemNotificationSettingsSlice";
import parentAccountsReducer from "./slices/parentAccountSlice";
import availableTemplatesSlice from "./slices/availableTemplatesSlice";
import accountsTagsSlice from "features/Accounts/state/slices/tagsSlice";
import addOnsReducer from "./slices/addOnsSlice";
import availablePacksReducer from "./slices/availablePacksSlice";
import availablePacksFiltersReducer from "./slices/availablePacksFiltersSlice";
import availableDomains from "features/Accounts/state/slices/accountDomainsSlice";
import addUserReducer from "./slices/addUser/addUserReducer";
import editAccountUsersSlice from "./slices/editAccountUsersSlice";
import accountDependenciesSlice from "./slices/accountDependenciesSlice";

const accountsReducer = combineReducers({
  edit: editAccountReducer,
  accountInformation: accountInformationReducer,
  creation: createAccountReducer,
  overview: combineReducers({
    grid: allAccountsOverviewReducer,
    filters: overviewFiltersReducer,
  }),
  mostAccessed: mostAccessedAccountsReducer,
  identityProviders: identityProvidersReducer,
  contractTypes: contractTypesReducer,
  subscriptionAgreement: subscriptionAgreementReducer,
  apiKeys: apiKeysReducer,
  integrations: integrationReducer,
  emailSettings: emailSettingsReducer,
  threatDefenceSettings: threatDefenceSettingsReducer,
  threatDefenceSmtpSettings: threatDefenceSmtpSettingsReducer,
  systemNotificationSettings: systemNotificationSettingsReducer,
  parentAccounts: parentAccountsReducer,
  availableTemplates: availableTemplatesSlice,
  tags: accountsTagsSlice,
  addOns: addOnsReducer,
  availablePacks: availablePacksReducer,
  availablePacksFilters: availablePacksFiltersReducer,
  availableDomains,
  addUser: addUserReducer,
  templateUsers: editAccountUsersSlice,
  accountDependencies: accountDependenciesSlice,
});

export default accountsReducer;
